import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import LandingPageEs from './pages/LandingPageEs';
import LandingPageEn from './pages/LandingPageEn';
import { Analytics } from "@vercel/analytics/react"
import DynaMapPage from './pages/DynaMapPage';
import BlogPage from './pages/BlogPage';
import AboutPage from './pages/AboutPage';
import DieselSoberaniaPage from './pages/DieselSoberaniaPage';


function App() {
  return (
    <Router>
      <Analytics/>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/en" element={<LandingPageEn />} />
          <Route path="/es" element={<LandingPageEs />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog/dynamap" element={<DynaMapPage />} />
          <Route path="/blog/eficiencia-energetica" element={<DieselSoberaniaPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;